import { useState, useEffect } from 'react'
import { Select } from '@planningcenter/tapestry'
import ExternalIcon from '~/components/external_icon'

const STORAGE_KEY = 'pco-api-docs-color-mode'

function getStoredPreference(): string {
  return localStorage.getItem(STORAGE_KEY) || 'system'
}

function applyTheme(preference: string) {
  const resolved =
    preference === 'system'
      ? matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
      : preference

  document.documentElement.setAttribute('data-color-mode', resolved)
  localStorage.setItem(STORAGE_KEY, preference)
}

const options = [
  {
    value: 'light',
    textValue: 'Light',
    label: (
      <>
        <ExternalIcon symbol="toolbar#sun" size={16} />
        <span>Light</span>
      </>
    ),
  },
  {
    value: 'dark',
    textValue: 'Dark',
    label: (
      <>
        <ExternalIcon symbol="toolbar#moon" size={15} />
        <span>Dark</span>
      </>
    ),
  },
  {
    value: 'system',
    textValue: 'System',
    label: (
      <>
        <ExternalIcon symbol="toolbar#display" size={16} />
        <span>System</span>
      </>
    ),
  },
]

export default function ThemeSelect() {
  const [value, setValue] = useState(getStoredPreference)

  useEffect(() => {
    if (value !== 'system') return

    const mq = matchMedia('(prefers-color-scheme: dark)')
    const handler = () => applyTheme('system')
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [value])

  return (
    <Select
      className="theme-select"
      complex
      label="Color theme"
      hideLabel
      options={options}
      value={value}
      onChange={(e) => {
        const next = e.currentTarget.value
        setValue(next)
        applyTheme(next)
      }}
    />
  )
}
